import classnames from "classnames";
import React from "react";

function Button({
  children,
  value,
  onChange,
  className,
  type = "normal",
  size,
  disabled,
  ...props
}) {
  const classes = classnames("grigora-input-button", className);
  return (
    <>
      {type === "normal" ? (
        <>
          {disabled ? (
            <button {...props} disabled className={classes}>
              {children}
            </button>
          ) : (
            <button {...props} className={classes}>
              {children}
            </button>
          )}
        </>
      ) : (
        <LoaderButton size={size} />
      )}
    </>
  );
}

const LoaderButton = ({ size, color = "blue" }) => {
  const classes = classnames(
    `flex border-2 border-${color}-500 items-center rounded    `,
    size,
  );

  return (
    <>
      <button className={classes}>
        <span className="flex justify-center items-center h-3 w-3 relative mr-1">
          <span className="animate-ping absolute inline-flex h-2 w-2 rounded-full bg-blue-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-1 w-1 bg-blue-500"></span>
        </span>
        <span className="flex justify-center items-center h-3 w-3 relative mr-1">
          <span className="animate-ping absolute inline-flex h-2 w-2 rounded-full bg-blue-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-1 w-1 bg-blue-500"></span>
        </span>
        <span className="flex justify-center items-center h-3 w-3 relative mr-1">
          <span className="animate-ping absolute inline-flex h-2 w-2 rounded-full bg-blue-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-1 w-1 bg-blue-500"></span>
        </span>
      </button>
    </>
  );
};

export default Button;
